export default class StartInactiveBrowser {
    url: string = '';
    enableMetaData: boolean = false;
}